enum EManagerEmailType {
  LICENSE_POOL = 'license_pool',
  OTHER = 'other',
}

export default EManagerEmailType;
